import {jwtDecode} from 'jwt-decode';
const { REACT_APP_BASE_URL } = process.env
export const baseUrl = REACT_APP_BASE_URL;

export const headers = {
    "Content-Type": "application/json",
}

export const jwtHeaders = () => {
    const headers = {
      'Content-Type': 'application/json',
      // Authorization: `Bearer ${JSON.parse(localStorage.getItem('aaradhak-admin'))?.token}`,
      Authorization: `${localStorage.getItem('single_branch_token')}`,
    };
    const token = headers.Authorization;
    // Decode the token to check its expiration
    const decodedToken = jwtDecode(token);
  
    // Check if the token has expired
    const currentTime = Date.now() / 1000; // current time in seconds
    if (decodedToken.exp && decodedToken.exp < currentTime) {
      localStorage.removeItem('single_branch_token');
      window.location.pathname = '/auth/login';
    }
    return headers;
  };

export const jwtFormDataHeaders = () => {
    const headers = {
        Authorization: `${localStorage.getItem('single_branch_token')}`,
    };
    return headers;
};

export const logoutUtil = () => {
    localStorage.removeItem("salon-branch");
    localStorage.removeItem("single_branch_token");
    window.location.href = "/login";
};